import React from 'react'
import {connect} from 'react-redux'
import {setBattleValue} from '../../redux-actions/battle-actions.js'

class ArenaTransitionOverlay extends React.Component {

  constructor() {
    super();
    this.state = {
      overlayOpacity: 1
    }
  }

  //Check if a transition is present on mount
  componentDidMount() {
    if (this.props.arenaTransitionOverlay) {
      this.handleTransitionKickoff(this.props);
    }
  }

  //Listen for transition models to come in
  componentWillUpdate(newProps) {
    //Check for model to be set in the arenaTransitionOverlay state
    //See model description below)
    if (newProps.arenaTransitionOverlay && !this.props.arenaTransitionOverlay) {
      //Incoming change!
      this.handleTransitionKickoff(newProps);
    }
  }

  handleTransitionKickoff(props) {
    //Case 1: fade OUT (battle starting)
    if (props.arenaTransitionOverlay.transition === "fadeOut") {
      //Set my opacity to 0 to start. Fade in to 1
      this.setState({ overlayOpacity:1 }, () => {
        setTimeout(() => {
          this.setState({ overlayOpacity:0 })
        }, 25) //Delay to make CSS transition fire
      })
    }

    //Case 2: fade IN (battle ending)
    if (props.arenaTransitionOverlay.transition === "fadeIn") {
      //Set my opacity to 0 to start. Fade in to 1
      this.setState({ overlayOpacity:0 }, () => {
        setTimeout(() => {
          this.setState({ overlayOpacity:1 })
        }, 25) //Delay to make CSS transition fire
      })
    }
  }


  handleTransitionEnd() {
    // console.log('transition over!');
    this.props.arenaTransitionOverlay.callback();

    //Reset state to null
    setBattleValue({
      arenaTransitionOverlay: null
    })
  }


  render() {

    //Default to nothing
    if (!this.props.arenaTransitionOverlay) {
      return null;
    }

    const style = {
      position: "absolute",
      zIndex: 100,
      left:0,
      right:0,
      top:0,
      bottom:0,
      background:"#fff",
      opacity: this.state.overlayOpacity,
      transition: "opacity 0.9s"
    };

    return (
      <div style={style} onTransitionEnd={this.handleTransitionEnd.bind(this)} />
    );
  }
}

export default connect((state, props) => {
  return {
    arenaTransitionOverlay: state.battle.arenaTransitionOverlay
  }
})(ArenaTransitionOverlay)


/*
Example model for prop:
 {transition: "fadeIn" | "fadeOut", callback: function }

 FadeIn = start at 0 opacity, transition to 1 then do callback
 */


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaTransitionOverlay.js